var Sok = (function () {
  /* ********** Exponerade funktioner     */
  function initSok() {
    const headersearchcontainer = document.getElementById(
      "header-search-container"
    );
    const searchbutton = document.getElementById("header-search-btn");
    if (headersearchcontainer && searchbutton) {
      headersearchcontainer.addEventListener("hidden.bs.collapse", (event) => {
        if (window.innerWidth <= window.mdMax) {
          document.body.classList.remove("fixed-top");
        }
      });

      headersearchcontainer.addEventListener("shown.bs.collapse", (event) => {
        if (window.innerWidth <= window.mdMax) {
          document.body.classList.add("fixed-top");
        }
        document.getElementById("headerSearchField").focus();
      });

      document.addEventListener("click", function (event) {
        if (
          !headersearchcontainer.contains(event.target) &&
          !headersearchcontainer.classList.contains("visasokheader") &&
          headersearchcontainer.classList.contains("show")
        ) {
          searchbutton.click();
        }
      });
    }
  }

  function generateUrlParamName(facetName) {
    if (facetName.length < 4) return facetName;
    return facetName.substring(0, 1) + facetName.charAt(facetName.length - 4) + facetName.charAt(facetName.length - 1);
  }

  function getText(facetName, key, texts) {
    if (facetName === 'starttermin') {
      return getTextStartTermin(key, texts);
    }
    return texts[key] || key;
  }

  function getTextStartTermin(key, texts) {
    if (key && key.length >= 4) {
      return texts[key.substring(0, 2)] + " 20" + key.substring(2);
    }
    return '';
  }

  return {
    initSok: initSok,
    generateUrlParamName: generateUrlParamName,
    getText: getText,
    getTextStartTermin: getTextStartTermin, 
  };
})();

export default Sok;
